/**
 * Copyright (C) 2021-2026 Technology Matters
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see https://www.gnu.org/licenses/.
 */

import { useState } from 'react';
import validator from 'validator';

const BLACKLIST_CHARS_FOR_CHAT_INPUT = '<;&/';
const BLACKLIST_CHARS_FOR_PRE_ENGAGEMENT_FORM_NAME_FIELD = '<>;:&/"';

export const useSanitizer = () => {
  const [userInput, setUserInput] = useState('');
  const onUserInputSubmit = (event: string, isNameField?: boolean): string => {
    const escapedUserInput = isNameField
      ? validator.blacklist(event, BLACKLIST_CHARS_FOR_PRE_ENGAGEMENT_FORM_NAME_FIELD)
      : validator.blacklist(event, BLACKLIST_CHARS_FOR_CHAT_INPUT);
    setUserInput(escapedUserInput);
    return escapedUserInput;
  };

  return {
    userInput,
    onUserInputSubmit,
  };
};
